import type { AxiosInstance } from 'axios';
import axios from 'axios';

const request: AxiosInstance = axios.create({
  timeout: 10000
});

request.interceptors.request.use((config) => {
  const csrfTokenTag = document.querySelector('meta[name="csrf-token"]');
  if (!csrfTokenTag) {
    return config;
  }

  config.headers.set('X-CSRF-Token', csrfTokenTag.getAttribute('content'));
  return config;
});

export default request;
